/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React from "react";
import { ReactElement } from "react";
import { VoorstelHypotheekHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";
import { Paragraph } from "../../components/Paragraph";
import Heading from "../../components/Heading";
import { Chapter } from "../../components/Chapter";
import { getLeningdelenColumns } from "../Producten/hypotheken-kolommen";

type HypotheekProps = {
  hypotheek: VoorstelHypotheekHoofdstuk;
};

const defaultChunkSize = 3;

const getLeningdelenOverview = (
  hypotheek: VoorstelHypotheekHoofdstuk
): ReactElement => {
  // @ts-ignore
  if (!hypotheek.leningdelenOverview?.length) {
    return <></>;
  }

  const columns: Column[] = [
    {
      header: "Geldverstrekker",
      accessor: "geldverstrekker",
      align: "right" as const,
      highlightColumn: true,
    },
    {
      header: "Totale hypotheeksom",
      accessor: "totaleHypotheeksom",
      align: "right" as const,
      dataType: "currency" as const,
    },
    {
      header: "Hypotheekinschrijving",
      accessor: "hypotheekinschrijving",
      align: "right" as const,
      dataType: "currency" as const,
    },
  ];

  const data = hypotheek.leningdelenOverview;

  return (
    <Table
      columns={columns}
      data={data}
      id="leningdelen-overview"
      rotate
      filterNullAnd0Columns={false}
      extraStyle="width: 50%;"
    ></Table>
  );
};

function splitIntoChunks(arr: any[], chunkSize = defaultChunkSize): any[][] {
  const chunks = [] as any[][];

  // @ts-ignore
  for (let i = 0; i < (arr as any[]).length; i += chunkSize) {
    // @ts-ignore
    const chunk = (arr as any[]).slice(i, i + chunkSize);
    // @ts-ignore
    (chunks as any[][]).push(chunk);
  }
  return chunks;
}

const getLeningdelenDetails = (
  hypotheek: VoorstelHypotheekHoofdstuk
): ReactElement => {
  // @ts-ignore
  if (!hypotheek.leningdelenDetails?.length) {
    return <></>;
  }

  const columns = getLeningdelenColumns("voorstel");

  const chunks = splitIntoChunks(hypotheek.leningdelenDetails || []) as any[][];

  return (
    <>
      {/* @ts-ignore */}
      {Array.from(chunks).map((chunk: any, index: number) => (
        <Table
          key={index}
          columns={columns}
          data={chunk}
          id={`leningdelen-details-${index}`}
          extraStyle="break-inside: avoid; page-break-inside: avoid;"
          rotate
          regularStyles={chunk?.length > 1}
        />
      ))}
    </>
  );
};

export const HypotheekChapter = ({
  hypotheek,
}: HypotheekProps): ReactElement => {
  return (
    <Chapter>
      {hypotheek.titel && <Heading text={`${hypotheek.titel}`} level={3} />}

      <Paragraph paragraaf={hypotheek?.paragrafen?.["p305060101"]} />

      {getLeningdelenOverview(hypotheek)}
      <br />
      {getLeningdelenDetails(hypotheek)}

      {hypotheek.paragrafen?.["p305060102"] && (
        <Paragraph withMarkdown>
          {hypotheek.paragrafen?.["p305060102"]?.inhoud ?? ""}
        </Paragraph>
      )}
    </Chapter>
  );
};
